import React, { FC, useMemo } from "react";
import Box from "react-raster";
import styled, { css } from "styled-components";
import { theme } from "../config/theme";
import * as SwitchPrimitive from '@radix-ui/react-switch';

const Container = styled.form<ToggleProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const Label = styled.span<ToggleProps>`
  font-size: ${theme.font.size.small};
  margin-right: 0.5rem;
`;

const SecondaryLabel = styled(Label)`
  margin-left: 0.5rem;
`

const ToggleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`
const StyledSwitch = styled(SwitchPrimitive.Root)`  
  all: unset;
  width: 3rem;
  height: 1.8rem;
  border-radius: 14px;
  background: ${theme.color.formElements.main};
  cursor: ${props => props.disabled ? "not-allowed" : "pointer"};

  &:hover:enabled {
    background: ${theme.color.formElements.hover};
  }

  &:active:enabled {
    background: ${theme.color.formElements.active};
  }

  &:disabled:hover {
    cursor: not-allowed;
  }

  &:focus:enabled {
    outline: 2px solid ${theme.color.blueA5};
  }

  &[data-state="checked"] {
    background: ${theme.color.formElements.toggleMain};
  }
`

const StyledThumb = styled(SwitchPrimitive.Thumb)`  
  display: block;
  width: 1.4rem;
  height: 1.4rem;
  border-radius: 50%;
  transition: transform 100ms;
  transform: translateX(2px);
  will-change: transform;
  background: ${theme.color.white};

  &[data-state="checked"] {
    transform: translateX(14px);
  }
`

type ToggleProps = {
  label?: string;
  $secondaryLabel?: string;
};

type SwitchPrimitiveProps = React.ComponentProps<typeof StyledSwitch>;
type SwitchProps = SwitchPrimitiveProps & ToggleProps;

export const Toggle = React.forwardRef<React.ElementRef<typeof StyledSwitch>, SwitchProps>(
  (props, forwardedRef) => (
    <Container>
      <ToggleContainer>
        <Label>{props.label}</Label>
        <StyledSwitch defaultChecked {...props} ref={forwardedRef}> {/* todo: look at the ref error */}
          <StyledThumb />
        </StyledSwitch>
        <SecondaryLabel>{props.$secondaryLabel}</SecondaryLabel>
      </ToggleContainer>
    </Container>
  )

);
